import { DateFormatter } from '@repo/toolkit/date'
import { StringFormatter } from '@repo/toolkit/string'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'
import React from 'react'

import { Paths } from '../../../lib/constants/path'
import useTranslate from '../../../lib/hooks/use-translate'
import { staffPositionEnumMapping } from '../../../lib/types/enums/staff/staff-position.enum'
import { staffQualificationEnumMapping } from '../../../lib/types/enums/staff/staff-qualifications.enum'
import { MissionToStaffExpenses } from '../../../lib/types/models/mission-to-staff/mission-to-staff'

type Props = {
  missionToStaff: MissionToStaffExpenses
}

const MissionToStaffProfile: React.FC<Props> = ({ missionToStaff }) => {
  const { t } = useTranslate()
  const { navigate } = useNavigator()
  return (
    <div className="p-3 rounded-2xl bg-white-active flex items-center gap-4">
      <img
        src={missionToStaff.staff.picture?.path ?? '/profile-default.jpg'}
        alt="photo du staff"
        className="w-20 h-20 rounded-xl object-cover"
      />
      <div className="flex-1">
        <Typography variant="body-medium">
          <Typography.Link
            variant="body-medium"
            onClick={() =>
              navigate(
                Paths.MISSION_VIEW_PAGE.replace(':id', missionToStaff.mission.id.toString())
              )
            }
          >
            {StringFormatter.capitalize(missionToStaff.staff.firstName)}{' '}
            {missionToStaff.staff.lastName.toUpperCase()}
          </Typography.Link>{' '}
          -{' '}
          <span className="text-grey-lighter">
            {missionToStaff.staff.city} ({missionToStaff.staff.postalCode})
          </span>
        </Typography>
        <div className="h-2" />
        <div className="p-2 bg-grey-light rounded-sm w-full flex flex-col gap-0.5 text-grey">
          <div className="flex flex-wrap items-center">
            {[
              <Typography key="position" variant="label-semibold">
                {t(staffPositionEnumMapping[missionToStaff.staff.position])}
              </Typography>,

              <Typography key="qualification" variant="label-semibold">
                {missionToStaff.mission.qualifications
                  .map((q) => t(staffQualificationEnumMapping[q].label))
                  .join(', ')}
              </Typography>
            ].map((node, i) => (
              <React.Fragment key={i}>
                {i !== 0 && <span className="mx-2 text-neutral-400">|</span>}
                {node}
              </React.Fragment>
            ))}
          </div>

          <Badge text={`Date : ${`${DateFormatter.DDMMYYYY(missionToStaff.mission.date)}`}`} />
        </div>
      </div>
    </div>
  )
}

export default MissionToStaffProfile
